import type theme from '#build/ui/badge'
import type { DeepPartial } from '@nuxt/ui'

const badge: DeepPartial<typeof theme> = {
  slots: {
    base: 'inline-flex max-w-full items-center font-normal leading-5',
  },
  variants: {
    color: {
      cloud: '',
    },
    variant: {
      'solid': 'rounded-sm',
      'outline': 'rounded-sm ring-1 ring-inset',
      'outline-strong': 'rounded-lg ring-2 ring-inset',
    },
    size: {
      sm: {
        base: 'gap-2 p-2 text-sm',
        leadingIcon: 'size-4',
        leadingAvatarSize: '3xs',
        trailingIcon: 'size-4',
      },
      md: {
        base: 'gap-2 p-2 text-base',
        leadingIcon: 'size-6',
        leadingAvatarSize: '3xs',
        trailingIcon: 'size-6',
      },
      lg: {
        base: 'gap-2.5 p-2.5 text-base',
        leadingIcon: 'size-8',
        leadingAvatarSize: '2xs',
        trailingIcon: 'size-8',
      },
    },
  },
  compoundVariants: [{
    color: 'primary',
    variant: 'solid',
    class: 'bg-cvt-purple-500 text-white',
  }, {
    color: 'primary',
    variant: ['outline', 'outline-strong'] as any,
    class: 'text-cvt-purple-500 ring-cvt-purple-500',
  }, {
    color: 'neutral',
    variant: 'solid',
    class: 'bg-cvt-purple-400 text-cvt-purple-500',
  }, {
    color: 'neutral',
    variant: ['outline', 'outline-strong'] as any,
    class: 'text-cvt-purple-400 ring-cvt-purple-400',
  }, {
    color: 'cloud' as any,
    variant: 'solid',
    class: 'bg-cvt-cloud-600 text-cvt-cloud-800',
  }, {
    color: 'cloud' as any,
    variant: ['outline', 'outline-strong'] as any,
    class: 'text-cvt-cloud-800 ring-cvt-cloud-800',
  }],
  defaultVariants: {
    color: 'primary',
    variant: 'outline',
    size: 'md',
  },
}

export default badge
